import { render } from "./ExpertsTable.vue?vue&type=template&id=5d6f1d84"
import script from "./ExpertsTable.vue?vue&type=script&lang=js"
export * from "./ExpertsTable.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__